import React, { Component, Fragment } from 'react'
import ForgotPassword from './ForgotPassword'
import Confirmation from './Confirmation'
import PropTypes from 'prop-types'

export default class ForgotPasswordUI extends Component {
    state = {
        email: '',
        showForgotPassword:true
    }

    showConfirmation = ( email ) => {
        this.setState( { showForgotPassword: false, email: email } )
    }

    render() {
        const { email,showForgotPassword } = this.state
        return (
            <Fragment>
                { showForgotPassword
                    ? <ForgotPassword showConfirmation={ this.showConfirmation } config={ this.props.config } />
                    : <Confirmation  email={ email } />
                }
            </Fragment>
        )
    }
}

ForgotPasswordUI.propTypes = {
    config: PropTypes.shape( {
        forgotPasswordApiUrl: PropTypes.string
    } )
}
